
import { Info } from "lucide-react";

export const NotificationPreview = () => {
  return (
    <div className="mt-8">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Notification Preview</h3>
      <div className="bg-gray-50 border border-gray-200 rounded-md p-4">
        <div className="flex items-center gap-2 mb-2">
          <Info className="h-4 w-4 text-blue-500" />
          <p className="text-sm font-medium">This is how notifications will appear</p>
        </div>
        <div className="p-3 bg-white rounded border border-gray-200 shadow-sm">
          <p className="font-medium">New article published: "The Future of AI"</p>
          <p className="text-sm text-gray-600 mt-1">Check out our latest article about artificial intelligence trends and predictions.</p>
        </div>
      </div>
    </div>
  );
};
